// Modules
import { FormattedMessage } from 'react-intl';
// Utils
import { DateAgo, isEmpty } from '~/utils';
// Styles
import styles from './view-publish.module.scss';

const ViewPublish = ({ viewCount, publishDate }) => {
  const hasDot = !isEmpty(viewCount) && viewCount !== 0 && !isEmpty(publishDate);

  return (
    <div className={styles['wrapper']}>
      {!isEmpty(viewCount) && viewCount !== 0 && (
        <span>
          <FormattedMessage
            id="apron.plus.view_count"
            values={{
              viewCount,
            }}
          />
        </span>
      )}
      {hasDot && <div>.</div>}
      {!isEmpty(publishDate) && <span>{DateAgo(publishDate)}</span>}
    </div>
  );
};

export default ViewPublish;
